import { twMerge } from "tailwind-merge"
export const bodySmallStyles = "text-[1rem] font-bold leading-[150%]"
const BodySmall: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, ...props }) => {
  return <p className={twMerge(bodySmallStyles, "my-[0.75rem] md:my-[1rem]", className)} {...props} />
}

export default BodySmall
